import { LangFa } from "./fa/Lang";
import { LangEn } from "./en/Lang";

let Lang = {};
if(process.env.REACT_APP_LANG === "en"){
    Lang = {
        ...LangEn
    }
} else {
    Lang = {
        ...LangFa
    }
}

export {Lang}